module.exports = __webpack_public_path__ + "static/media/rogue-win.b9edd741.png";